<div class="flex justify-between max-xs:flex-col w-full">
  <ng-container *ngIf="appointmentServices$ | async as data">
    <div class="service-item__info flex-1 order-1 max-xs:order-2">
      <div class="flex service-item w-full" *ngFor="let service of data" data-test-id="appointment-service-block">
        <div class="w-full">
          <div class="service-item__name text-[20px] font-medium mb-[8px]"
          data-test-id="appointment-service-name">{{ service.serviceName }}</div>
          <pub-service-duration-and-price class="mb-[8px]" [duration]="service.totalDuration" [price]="service.price" data-test-id="appointment-duration-and-price">
          </pub-service-duration-and-price>
          <div class="service-item__name text-[17px] font-medium line-clamp-1 break-words  w-full" data-test-id="appointment-employee-name">
            <ng-container *ngIf="service.employee; else noEmployeeSelection">
              {{ service.employee.firstName }} {{ service.employee.lastName }}
            </ng-container>
            <ng-template #noEmployeeSelection>
              <pub-no-employee-selection data-test-id="appointment-no-employee"></pub-no-employee-selection>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="startDate$ | async as startDate">
    <pub-date-widget [date]="startDate" class="ml-[80px] max-xs:ml-0 order-2 max-xs:order-1"></pub-date-widget>
  </ng-container>
</div>

<hr class="separator mb-[20px] mt-[25px]" />

<div
  class="text-[14px] font-bold leading-[24px]"
  [translate]="'bookingPage.confirmAppointmentPage.totalAmount'"
  [translateParams]="{ amount: (appointmentServicesSum$ | async | formatMoney) }"
  data-test-id="appointment-total-price"></div>

<pub-appointment-external-note class="mt-[25px] empty:hidden"></pub-appointment-external-note>

<hr class="separator mt-[25px]" />
